import React from "react";
import { Switch, Route } from "react-router-dom";
// Pages
import About from "./pages/About";
import Home from "./pages/Home";
import Team from "./pages/Team";
// Questionnaire
import StartQuestionnaire from "./pages/Start-questionaire";
import Questionnaire from "./pages/Questinaire/Questionaire";
import ResultPage from "./pages/Questinaire/ResultPage";
// Styles and Nav
import GlobalStyles from "./components/GlobalStyles";
import { AnimatePresence } from "framer-motion";

function App() {
  // const location = useLocation();
  return (
    <React.Fragment>
      <GlobalStyles />
      <AnimatePresence exitBeforeEnter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact strict path="/start" component={StartQuestionnaire} />
          <Route exact strict path="/questionnaire" component={Questionnaire} />
          <Route exact strict path="/result" component={ResultPage} />
          <Route path="/about" exact strict component={About} />
          <Route path="/team" exact strict component={Team} />
        </Switch>
      </AnimatePresence>
    </React.Fragment>
  );
}

export default App;
